<template>
  <div class="p-16 px-8 md:px-16" :class="{ ['bg-' + background]: true }">
    <div class="text-blue-darker container mx-auto flex items-center justify-center" :class="inversed ? 'flex-col md:flex-row-reverse' : 'flex-col md:flex-row'">
      <div :class="inversed ? 'mb-8 md:mb-0 md:ml-32' : 'mb-8 md:mb-0 md:mr-32'">
        <div class="font-bold text-3xl">
          <slot></slot>
        </div>
        <div class="mt-4 font-light">
          <slot name="description"></slot>
        </div>
      </div>

      <img v-if="image" :src="image" alt="Todoninja screenshot" class="shadow-md rounded-lg max-w-xs md:max-w-1/3"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: 'blue-lightest',
    },
    inversed: {
      type: Boolean,
      default: false,
    },
    image: String,
  },
};
</script>
